import React, { FC } from "react";
import {
  CollapsiblePanel,
  CustomLabel,
  FlexContainer,
  IOption,
  SingleSelect,
} from "@mindmemobile/mm-shared-global";
import {
  MerchantAccount,
  PurchaseLinkModel,
  SellerModel,
} from "../../../shared/models";
import { MerchantAccountsDropDown } from "../../../shared/components";

type IProps = {
  handleInputChange: (
    field: keyof PurchaseLinkModel,
    value: MerchantAccount | IOption
  ) => void;
  selectedMerchantAccount: MerchantAccount;
  selectedSeller: SellerModel;
  merchantAccounts: MerchantAccount[];
  merchantHasError: boolean;
  sellerHasError: boolean;
  sellers: SellerModel[];
};
const PurchaseLinkAdvancedSection: FC<IProps> = ({
  selectedMerchantAccount,
  selectedSeller,
  handleInputChange,
  merchantAccounts,
  merchantHasError,
  sellerHasError,
  sellers,
}) => {
  const renderMerchantAccountSection = () => {
    return (
      <div>
        <CustomLabel>Merchant Account</CustomLabel>
        <MerchantAccountsDropDown
          selectedMerchantAccount={selectedMerchantAccount}
          merchantAccounts={merchantAccounts}
          showError={merchantHasError}
          onChange={(option) =>
            handleInputChange("selectedMerchantAccount", option)
          }
          className="white-bg dpdn-with-icons merchant-account-dropdown"
        />
      </div>
    );
  };

  const renderSoldBySection = () => {
    return (
      <div className="pl-last-dropdown">
        <CustomLabel>Sold By</CustomLabel>
        <SingleSelect
          selectedKey={selectedSeller.name}
          nameKeys={["name"]}
          valueKeys={["id"]}
          options={[sellers]}
          customHeader={
            selectedSeller.name ? (
              <FlexContainer spacing={10} alignItems="center">
                {selectedSeller?.id ? selectedSeller.name : "Select Seller"}
              </FlexContainer>
            ) : (
              "Select Seller"
            )
          }
          customOption={(option: SellerModel) => (
            <FlexContainer
              padding="0px 0px 5px"
              key={option.id}
              spacing={10}
              alignItems="center"
            >
              <span>{option.name}</span>
            </FlexContainer>
          )}
          onChange={(option) => handleInputChange("selectedSeller", option)}
          className={"dpdn-with-icons sold-by-dropdown"}
          searchable={false}
          hasError={sellerHasError}
        />
      </div>
    );
  };
  return (
    <>
      <CollapsiblePanel title="Advanced" className="pl-advance-section">
        <FlexContainer
          fxLayout="column"
          spacing={30}
          className="pl-input-labels full-width"
        >
          {renderMerchantAccountSection()}
          {renderSoldBySection()}
        </FlexContainer>
      </CollapsiblePanel>
    </>
  );
};

export default PurchaseLinkAdvancedSection;
